import { c as _c } from "react/compiler-runtime";
import { AnimationProps } from "./types";
const Animation = t0 => {
  const $ = _c(2);
  const {
    axis,
    reverse,
    name
  } = t0;
  const t1 = `
        @keyframes ${name} {
          from {
            transform: translate${axis || "X"}(${reverse ? 0 : -50}%);
          }
          to {
            transform: translate${axis || "X"}(${reverse ? -50 : 0}%);
          }
        }
      @media (prefers-reduced-motion) {
          animation: none;
      }
      `;
  let t2;
  if ($[0] !== t1) {
    t2 = <style>{t1}</style>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};
export default Animation;